export default __webpack_public_path__ + "static/bg-m-af5e6929f9e8173701d1bab303a9cb9a.png";